import React from 'react';
import Accordion from "./Accordion";

const Faqs = ({faqs}) => {

    return (
        <section className={'faqs'}>
            <div className="container">
                <div className="faqs_wrapper">
                    <h1 className={'faqs_title'}>{faqs.title}</h1>
                    <div className={'faqs_list'}>
                        <Accordion
                            items={faqs.list}
                        />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Faqs;